export default __webpack_public_path__ + "static/logo-76dcf616ed74fce0610927ecedf5512b.png";